<template>
    <v-container fluid class="pa-0">
        <v-card>
            <v-card-title primary-title>
                <v-row>
                    <v-col>Material Sample SOPs</v-col>
                    <v-spacer />
                    <v-col class="text-right">
                        <v-btn color="primary" @click="handleCreateSampleSOP"
                            >New SOP</v-btn
                        >
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <MaterialSamplesSOPList
                    :sampleSOPs="sampleSOPs"
                    :materialTypes="materialTypes"
                    :sampleDescriptors="sampleDescriptors"
                    :search="props.search"
                    @editSamplesSOP="handleEditSamplesSOP"
                />
            </v-card-text>
        </v-card>
        <v-dialog v-model="materialSampleSOPsDialogVisible" max-width="800px">
            <MaterialSamplesSOPForm
                :existingSOP="selectedSOP"
                :materialTypes="materialTypes"
                :sampleDescriptors="sampleDescriptors"
                @canceled="materialSampleSOPsDialogVisible = false"
                @samplesSOPSaved="handleSamplesSOPSaved"
            />
        </v-dialog>
    </v-container>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { withLoadingScreen } from "@/lib/loading.js";
import { samplesAPI, SavedMaterialSampleSOP, MaterialSampleSOP, MaterialType, SampleDescriptor } from "@/services/samples/samplesAPI";
import MaterialSamplesSOPList from "@/components/SamplesV2/MaterialSamplesSOPList.vue";
import MaterialSamplesSOPForm from "./MaterialSamplesSOPForm.vue";

interface Props {
    search: string
}

const props = withDefaults(defineProps<Props>(), {
    search: "",
});

const sampleSOPs = ref<SavedMaterialSampleSOP[]>([]);
const materialSampleSOPsDialogVisible = ref(false);
const selectedSOP = ref<SavedMaterialSampleSOP | undefined>(undefined);
const materialTypes = ref<MaterialType[]>([]);
const sampleDescriptors = ref<SampleDescriptor[]>([]);

async function reloadSampleSOPs() {
    await withLoadingScreen(async () => {
        sampleSOPs.value = await samplesAPI.fetchSampleSOPs();
    });
}

onMounted(async () => {
    await reloadSampleSOPs();
    materialTypes.value = await samplesAPI.fetchMaterialTypes();
    sampleDescriptors.value = await samplesAPI.fetchSampleDescriptors();
});

function handleCreateSampleSOP() {
    selectedSOP.value = undefined;
    materialSampleSOPsDialogVisible.value = true;
}

function handleEditSamplesSOP(sampleSOP: SavedMaterialSampleSOP) {
    selectedSOP.value = sampleSOP;
    materialSampleSOPsDialogVisible.value = true;
}

async function handleSamplesSOPSaved(_savedSOP: MaterialSampleSOP) {
    materialSampleSOPsDialogVisible.value = false;
    selectedSOP.value = undefined;
    await reloadSampleSOPs();
}

</script>
